const date = new Date();

export const localDate = date.toLocaleString("default", {
  day: "numeric",
  month: "long",
  year: "numeric",
});

export const utcTimeDate = (date) => {
  const newTransactionDate = new Date(date).toLocaleString("en-au", {
    hour12: true,
    day: "2-digit",
    month: "2-digit",
    year: "numeric",
    hour: "2-digit",
    minute: "2-digit",
  });

  return newTransactionDate.replace(",", "");
};

export const getDateXDaysAgo = (numOfDays, date = new Date()) => {
  const daysAgo = new Date(date.getTime());

  daysAgo.setDate(date.getDate() - numOfDays);
  daysAgo.setHours(0, 0, 0, 0);

  return daysAgo;
};

export const toDateString = (date = new Date()) => {
  let dayOfMonth = Number(date?.getDate());
  let month = Number(date?.getMonth()) + 1;
  let year = Number(date?.getFullYear());

  if (dayOfMonth < 10) {
    dayOfMonth = `0${dayOfMonth}`;
  }

  if (month < 10) {
    month = `0${month}`;
  }

  return `${year}-${month}-${dayOfMonth}`;
};

export const toFriendlyDate = (date = new Date()) =>
  date
    .toLocaleString("en-au", {
      weekday: "short",
      day: "numeric",
      month: "short",
      year: "numeric",
    })
    ?.replace(",", "") ?? "";

export const timezone =
  new Date()
    .toLocaleTimeString("en-au", { timeZoneName: "short" })
    ?.split(" ")
    ?.slice(-1)[0] ?? "";
